import { query as containerQuery } from '@/services/internal/facility/Container';
import { formatMessage } from 'umi/locale';
/** 用于组件调用后台，避免与主模块数据产生影响 */
export default {
  namespace: 'com',

  state: {
    containerData: {
      list: [],
      pagination: {}
    },
  },

  effects: {
    *queryContainer({ payload, callback }, { call, put }) {
      const response = yield call(containerQuery, payload);
      if (response.success) {
        yield put({
          type: 'onContainerQuery',
          payload: {
            list: response.data.records ? response.data.records : [],
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            },
          },
        });
      }
      if (callback) {
        callback(response);
      }
    },
  },

  reducers: {
    onContainerQuery(state, action) {
      return {
        ...state,
        containerData: action.payload,
      };
    },
  },
};
